module.exports = __webpack_public_path__ + "img/2021_michigan_2.7e93beeb.jpg";